'use strict';

var flex = require('../../../../../../../../_virtual/flex.cjs');

var hasRequiredFlex;

function requireFlex () {
	if (hasRequiredFlex) return flex.__exports;
	hasRequiredFlex = 1;

	var JustifyContentOptions = /*#__PURE__*/ function(JustifyContentOptions) {
	    JustifyContentOptions["center"] = "center";
	    JustifyContentOptions["flexEnd"] = "flex-end";
	    JustifyContentOptions["flexStart"] = "flex-start";
	    JustifyContentOptions["spaceAround"] = "space-around";
	    JustifyContentOptions["spaceEvenly"] = "space-evenly";
	    JustifyContentOptions["spaceBetween"] = "space-between";
	    return JustifyContentOptions;
	}({});
	var AlignItemOptions = /*#__PURE__*/ function(AlignItemOptions) {
	    AlignItemOptions["center"] = "center";
	    AlignItemOptions["flexEnd"] = "flex-end";
	    AlignItemOptions["flexStart"] = "flex-start";
	    return AlignItemOptions;
	}({});

	flex.__exports.AlignItemOptions = AlignItemOptions;
	flex.__exports.JustifyContentOptions = JustifyContentOptions;
	
	return flex.__exports;
}

exports.__require = requireFlex;
//# sourceMappingURL=flex.cjs.map
